<template>
  <div>
    <section class="NavMenu_type" :class="isScrolledToTop && active == 1?'index-home':''">
        <div class="NavMenu-content">
            <div class="NavMenu-title" @click="toCenter('/index.html')">
                <img src="@/assets/index/logo.png" alt="" style="cursor: pointer;">
                <div class="NavMenu-title-txt">
                    二连浩特跨境电商综试区线上综合服务平台
                </div>
            </div>
            <!-- 导航 -->
            <div class="NavMenu-list-wrapper">
                <div class="NavMenu-list" >
                    <div v-for="(item,index) in menu" :key="index" :class="{'NavMenu-list-li':'NavMenu-list-li','NavMenu-list-li-active':item.id==active}">
                        <el-popover
                            placement="bottom"
                            width="100"
                            :disabled="item.id != 9"
                            trigger="hover">
                            <div class="popover_container">
                                <a class="popover_item" href="./showCompany.html">企业展厅</a>
                                <a class="popover_item" @click="joinCompany">企业入驻</a>
<!--                                <a class="popover_item" href="./companyJoin.html">企业入驻</a>-->
                            </div>
                            <a slot="reference" :href="item.id != 9?item.url:'javascript:;'">{{item.name}}</a>
                            <div class="NavMenu-list-li-hover"></div>
                        </el-popover>
                    </div>
<!--                    <span v-for="(item,index) in menu" :key="index" :class="{'NavMenu-list-li':'NavMenu-list-li','NavMenu-list-li-active':item.id==active}"><a :href="item.url">{{item.name}}</a> <div class="NavMenu-list-li-hover"></div></span>-->
                </div>
            </div>
            <a href="search.html" class="search-icon">
                <img src="@/assets/index/index_icon21.png" alt="">
            </a>
            <!-- <div class="NavMenu-search">
                <img src="@/assets/index/search.png" @click="submitSearch()">
                <input type="text" v-model="search" @keyup.enter="submitSearch()" placeholder="请输入搜索关键字">
            </div> -->
            <div class="NavMenu-operation">
                <div class="NavMenu-title-right" v-if="!islogin" @click="onLogin">
                    登录注册
                    <!-- <a href="javascript:void(0);" @click="onLogin">登录</a> -->
                    <!-- <a href="./register.html">注册</a> -->
                </div>
                <div v-else class="NavMenu-title-info">
                    <!--  -->
                    <span class="NavMenu-title-type">{{getUserType()}}</span>
                    <!-- 个人中心 -->
                    <el-popover placement="top" rigger="manual" v-model="visible" popper-class="popover">
                        <div class="popover-nav">
                            <div v-for="(item,index) in serverList">
                                <div v-if="serverList.length==1">
                                    <p @click="toCms(item.interfacePath)">{{item.serverName}}</p>
                                    <p class="systemline"></p>
                                </div>
                                <div v-else-if="index=='0' &&item.systemType==serverList[index+1].systemType">
                                    <p @click="toCms(item.interfacePath)">{{item.serverName}}</p>
                                </div>
                                <div v-else-if="index!='0'&& index!=(serverList.length-1) &&item.systemType==serverList[index+1].systemType">
                                    <p @click="toCms(item.interfacePath)">{{item.serverName}}</p>
                                </div>
                                <div v-else>
                                    <p @click="toCms(item.interfacePath)">{{item.serverName}}</p>
                                    <p class="systemline"></p>
                                </div>
                            </div>
                            <p @click="goback">退出</p>
                        </div>
                        <!-- <el-button slot="reference">李明</el-button> -->
                        <span slot="reference" class="NavMenu-title-slot">{{user}}<i :class="{'el-icon-caret-bottom':!visible,'el-icon-caret-top':visible}"></i></span>
                    </el-popover>
                    <!--  -->
                </div>
            </div>
        </div>
        <div class="banner-background"></div>
    </section>
    <div style="width: 100vw;height: 112px;"></div>

      <!-- <upgrade ref="upgrade"></upgrade> -->
      <upgrade-edit ref="upgradeEdit"></upgrade-edit>
</div>




</template>
<script>
/**
 * Component Nav_Menu 菜单导航组件
 	@author fanjun
 	@props data（必选属性前面带＊，非必选项目请备注默认值）
 		－*type : String,'1'(默认) - 1首页模板 、 2资讯模板  3、个人中心模板
 		－*active : String,'1'(默认)  默认激活的菜单
	@example
	<Nav-menu v-bind="{'type':'1','active':'1'}"/>
**/
// import upgrade from './add.vue'
import upgradeEdit from './edit.vue'
import { Checkbox ,Menu,MenuItem,Submenu ,Popover ,Button} from 'element-ui';
import bus from '../bus.js'
// import './index.scss'
import {doLogout} from "@/api/api";
export default {
  name: 'Nav',
  components:{
      // upgrade,
      upgradeEdit,
    [Checkbox.name]:Checkbox,
    [Menu.name]:Menu,
    [MenuItem.name]:MenuItem,
    [Submenu.name]:Submenu,
    [Popover.name]:Popover,
    [Button.name]:Button
  },
  props:{
    type: {
      type: String,
      required: true,
      default: '1'
    },
    active: {
      type: String,
      required: true,
      default: '1'
    },
    isScrolledToTop: {
      type: Boolean,
      default: false
    },
  },
  data(){
    return{
      islogin:window.sessionStorage.getItem('isLogin')?window.sessionStorage.getItem('isLogin'):false,
      user: window.sessionStorage.getItem('officialWebsiteUserMsg')?JSON.parse(window.sessionStorage.getItem('officialWebsiteUserMsg')).webUserName:'',
      activeIndex: '1',
      visible: false,
      menu: [
        {
          url: './index.html',
          name: '首页',
          id: '1',
          menuNumber:'1',
          child:[]
        },
        {
          url: './policy.html',
          name: '政策法规',
          id: '2',
          menuNumber:'152',
          child:[]
        },
        {
          url: './tradeNews.html',
          name: '行业新闻',
          id: '3',
          menuNumber:'153',
          child:[]
        },
        {
          url: './notification.html',
          name: '通知公告',
          id: '4',
          menuNumber:'154',
        },
        {
          url: './clearance.html#/parameter',
          name: '通关工具',
          menuNumber:'186',
          id: '5',
        },
        // {
        //   url: './dataQuery.html#/personal',
        //   name: '数据查询',
        //   id: '6',
        //   menuNumber:'197',
        // },
        // {
        //   url: './financialProducts.html#/ccbconnect',
        //   name: '金融产品',
        //   id: '7',
        //   menuNumber: '',
        // },
        {
          url: './synopsis.html#/synopsis',
          name: '综试区介绍',
          id: '8',
          menuNumber: '',
        },
        {
          url: './showCompany.html',
          name: '企业展厅',
          id: '9',
          menuNumber: '',
        }
      ],
      serverList: [],
      search: '',
    }
  },
  created(){
    this.init();
    this.Bus();
    if(this.islogin){
      this.userPower()
    }
    if(this.getQueryVariable('search')){
      this.search=decodeURI(this.getQueryVariable('search'));
    }
  },
  mounted(){
    // 如果是boss账号：bjcbecsys，则打开入口
    if(window.sessionStorage.getItem('officialWebsiteUserMsg') && JSON.parse(window.sessionStorage.getItem("officialWebsiteUserMsg")).webUserName=='bjcbecsys' ){
      setTimeout(()=>{
        this.visible = true
      },500)
    }
  },
  methods: {
      joinCompany() {
        if (window.sessionStorage.getItem('isLogin') != "true") {
          this.onLogin()
        } else {
          this.$refs.upgradeEdit.init();
        }
      },
    // 搜索方法
    submitSearch(){
      if(this.search==''){
        return this.$message.warning('请输入搜索关键字');
      }
      window.location.href = './search.html?search='+this.search
    },
    // 触发登录状态
    Bus(){
      bus.$on('islogin',(msg)=>{
        this.islogin = msg;
        this.user =  window.sessionStorage.getItem('officialWebsiteUserMsg')?JSON.parse(window.sessionStorage.getItem('officialWebsiteUserMsg')).webUserName:'';
        this.getUserType();
        this.userPower();
      })
      bus.$on('openDrop',()=>{
        this.visible = true;
      })
    },
    // 获取菜单名称
    init(){
      this.$api.getqueryMenu({
        "webServerId" : '1',
        "menuLevel" : "1"
      }).then(res=>{
        if(res.data.resultCode==200){
          res.data.result.map(ele=>{
            this.menu.map((v,index)=>{
              if(v.menuNumber==ele.id){

                this.$set(this.menu[index],'name',ele.categoryTitle)
                // v.name= ele.category_title;
                console.log(ele.categoryTitle)
              }
            })
          })
        }else{
          this.$message.error({title:res.data.resultDesc})
        }
      }).catch(err=>{
        console.log(err)
      })
    },
    onLogin(){
      const currentUrl = new URL(location.href);
      // 拼接 协议 + 主机+端口
      const baseUrlWithProtocol = currentUrl.protocol + '//' + currentUrl.host ;
      // const baseUrlWithProtocol = currentUrl.protocol + '//' + currentUrl.host + '/officialWebsite';
      this.$api.getSsoAuthUrl({clientLoginUrl: baseUrlWithProtocol}).then(res => {
        console.log(res.data)
        location.href = res.data.data;
      }).catch(err=>{
        console.log(err)
      })


      // window.location.href = "http://192.168.31.128:8088/office-api/gatewayWebsiteServer/login/casLogin"
      // if(process.env.NODE_ENV == 'development'){
      //   window.location.href = process.env.VUE_APP_BASE_API + "/gatewayWebsiteServer/login/casLogin"
      // }else{
      //   window.location.href = this.$api.base + "/gatewayWebsiteServer/login/casLogin"
      // }
    },
    getParam(name, defaultValue){
      var query = window.location.search.substring(1);
      var vars = query.split("&");
      for (var i=0;i<vars.length;i++) {
        var pair = vars[i].split("=");
        if(pair[0] == name){return pair[1];}
      }
      return(defaultValue == undefined ? null : defaultValue);
    },
    getUserType(){
      let type = JSON.parse(window.sessionStorage.getItem("officialWebsiteUserMsg"))
      if(type.webUserType == '0'){
        return '个人用户'
      }
      if(type.webUserType == '1'){
        return '企业用户'
      }
      if(type.webUserType == '3'){
        return '监管用户'
      }
      if(type.webUserType == '4'){
        return '管理用户'
      }
      if(type.webUserType == '5'){
        return '入驻企业'
      }
    },
    userPower(type){
      this.$api
      .queryAllWebServer({userId:JSON.parse(window.sessionStorage.getItem('officialWebsiteUserMsg')).webUserId})
      .then(res => {
        if (res.resultCode == 200) {
          this.serverList = res.result
        }
      })
      .catch(error => {
        console.log(error);
        this.$message.error("系统异常");
      });
    },
    activeLi(){
      if(type=='1'){
        return '4px solid #fff '
      }else{
        return '4px solid #0067FF '
      }
    },
    toCenter( href){
      window.location.href= href;
    },
    toCms(url){
      // if(process.env.NODE_ENV == 'development'){
      //   let path = url.split('#')[1]
      //   window.open('http://localhost:8080/#'+path)
      // }else{
        window.open(url)
      // }
    },
    goback(){
      this.$api.doLogout().then(res => {
        window.sessionStorage.clear();
        window.localStorage.clear();
        this.$message.success('退出成功');
        window.location.href = '/'
      })
      //
      //
      //
      //
      // console.log(this)
      // this.islogin = false;
      // window.sessionStorage.clear();
      // this.$notify.success({ title: '退出成功' });
      // // this.$message.success({title:'退出成功'})
      // window.location.href = this.$api.base + "/gatewayWebsiteServer/login/userExit"
      // window.location.href='./index.html'
    }
  }
}
</script>

<style scoped lang="scss">
.NavMenu_type {
    width: 100%;
    transition: all 0.6s;
    position: fixed;
    top: 0;
    left: 0;
    background-size: 100% 100%;
    z-index: 1000;
}

.NavMenu-content {
    width: 100%;
    min-width: 1560px;
    height: 112px;
    margin: 0 auto;
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    background: #123289;
    .NavMenu-title {
        display: flex;
        flex-direction: row;
        align-items: center;
        cursor: pointer;
        img{
            width: 72px;
            height: 72px;
            margin-right: 16px;
        }
        .NavMenu-title-txt{
            font-size: 18px;
            font-weight: 500;
            color: #FFFFFF;
            width: 198px;
        }
    }
    .NavMenu-list-wrapper{
        margin-left: 50px;
    }
    .NavMenu-list {
        display: flex;
        flex-direction: row;
        align-items: center;
        .NavMenu-list-li {
            display: inline-block;
            font-size: 18px;
            height: 72px;
            line-height: 72px;
            cursor: pointer;
            position: relative;
            margin-right: 50px;
            box-sizing: border-box;
            a {
                color: #fff;
                display: block;
            }
            &:hover {
                border-bottom: 4px solid #fff !important;
            }
        }
    }
    .search-icon{
        border-left: 1px solid rgba(255, 255, 255, 0.5);
        padding-left: 32px;
        cursor: pointer;
        img{
            width: 22px;
            height: 22px;
        }
    }
    .NavMenu-operation{
        margin-left: 40px;
        .NavMenu-title-right {
            width: 120px;
            height: 44px;
            background: linear-gradient(0deg, #C8D6FF 0%, #FFFFFF 100%);
            border-radius: 24px;
            text-align: center;
            font-size: 18px;
            color: #09173E;
            line-height: 44px;
            cursor: pointer;
            &:hover{
                opacity: 0.8;
            }
        }
    }
    .NavMenu-search{
        width: 224px;
        height: 30px;
        padding-left: 36px;
        position: absolute;
        right: 0;
        top: 11px;
        background: #fff;
        border-radius:16px;
        img{
            width: 16px;
            height: 16px;
            position: absolute;
            left: 12px;
            top: 8px;
        }
        input{
            width: 200px;
            height: 16px;
            float: left;
            margin-top: 7px;
            border: 0;
        }
    }
    .NavMenu-list-li-active{
        border-bottom: 4px solid #fff !important;
    }
}

.el-popover {
    min-width: 60px !important;
}

.NavMenu-title-info {
    .NavMenu-title-type {
        padding: 10px 24px;
        line-height: 26px;
        font-size: 18px;
        color: #FFFFFF;
        margin-right: 24px;
        border-radius: 24px;
        background: rgba(200, 214, 255, 0.25);
    }
    .NavMenu-title-slot {
        display: inline-block;
        position: relative;
        color: #FFFFFF;
    }
}
.systemline{
    width: 100%;
    height: 1px;
    margin: 5px 0px !important;
    border-bottom: 1px solid #dcdfe6;
    box-sizing: border-box;
}

.index-home{
    .NavMenu-content{
        background: transparent;
    }
}
</style>
<style>
.popover{
    padding: 10px 0 !important;
    text-align: left;
    .popover-nav{
        p{
            line-height: 36px;
            padding: 0 20px;
            margin: 0;
            font-size: 14px;
            color: #606266;
            cursor: pointer;
            outline: 0;
            &:hover{
                background: rgb(236, 245, 255);
                color: #409EFF;
            }
        }
    }
}
.popover_container{
    .popover_item{
        height: 50px;
        line-height: 50px;
        text-align: center;
        color: #333;
        display: block;
        cursor: pointer;
        &:hover{
            background: #005ADE;
            color: #fff;
        }
    }
}
</style>
